module.exports = __webpack_public_path__ + "static/7-08aa9f396154ad516dd15343c0bd1d4c.jpeg";